import { __assign, __spreadArray } from 'tslib';
import React__default, { useState, useEffect } from 'react';
import { Box, InputLabel, Autocomplete, TextField } from '@mui/material';
import clsx from 'clsx';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import trim from 'lodash/trim';
import uniqueId from 'lodash/uniqueId';
import DefaultIcon from '../../DefaultIcon/index.js';

var FieldSuggestion = function (_a) {
    var title = _a.title, description = _a.description, values = _a.values, onChange = _a.onChange, onBlur = _a.onBlur, getOptions = _a.getOptions, id = _a.id, className = _a.className, sx = _a.sx, _b = _a.testId, testId = _b === void 0 ? "FieldSuggestion" : _b, error = _a.error, helperText = _a.helperText, invertColors = _a.invertColors, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    var _d = useState([]), options = _d[0], setOptions = _d[1];
    useEffect(function () {
        if (getOptions) {
            getOptions().then(function (opt) { return setOptions(opt); });
        }
    }, [getOptions]);
    var inputId = uniqueId("field-suggestion");
    return (React__default.createElement(Box, { className: clsx("FieldSuggestion", className), id: id, sx: sx, "data-testid": testId },
        React__default.createElement(InputLabel, { sx: __assign({ fontWeight: "bold", fontSize: "0.8rem" }, (invertColors && { color: "white" })), htmlFor: inputId },
            title,
            description && (React__default.createElement(Box, { component: "span", title: description },
                React__default.createElement(KIcon, { sx: {
                        fontSize: function (theme) { return theme.spacing(2); },
                        marginLeft: function (theme) { return theme.spacing(1); },
                        width: "2em"
                    }, className: "fa-regular fa-circle-question " })))),
        React__default.createElement(Autocomplete, { id: inputId, "data-testid": "".concat(testId, "-input"), multiple: true, freeSolo: true, selectOnFocus: true, clearOnBlur: true, handleHomeEndKeys: true, value: values, onChange: onChange, renderInput: function (params) {
                return (React__default.createElement(TextField, __assign({}, params, { fullWidth: true, size: "small", autoComplete: "off", sx: __assign(__assign({}, (invertColors && { background: "white" })), { borderRadius: function (theme) { return theme.spacing(0.5); } }), error: error, helperText: helperText, onBlur: function (event) {
                        if (isString(event.target.value)
                            ? !!trim(event.target.value)
                            : isEmpty(event.target.value)) {
                            onChange(event, __spreadArray(__spreadArray([], values, true), [event.target.value], false));
                        }
                        onBlur && onBlur(event);
                    } })));
            }, options: options })));
};

export { FieldSuggestion as default };
//# sourceMappingURL=index.js.map
